export default __webpack_public_path__ + "static/7-8b1204b2d4afe3341531c6a30ad9f59c.woff";